import { useUnit } from 'effector-react';
import { Tree } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import style from './Heatmap.module.css';
import {
  $hexProperty,
  $showHeatmap,
  changeHexPropertyEv,
} from '../../models/investProModel/index.js';

const treeData = [
  {
    title: 'Количество АЗС',
    key: 'count_gas_station',
  },
  {
    title: 'Количество парковок',
    key: 'count_parking',
  },
  {
    title: 'Количество СТО',
    key: 'count_tech_services',
  },
  {
    title: 'Максимальный уровень пробок',
    key: 'min_traffic_level',
  },
  {
    title: 'Плотность объектов бизнеса',
    key: 0,
    checkable: false,
    children: [
      {
        title: 'Досуг, туризм и проживание',
        key: 'count_dosug',
      },
      {
        title: 'Здоровье и красота',
        key: 'count_health_beauty',
      },
      {
        title: 'Некоммерческие организации',
        key: 'count_non_commercial_org',
      },
      {
        title: 'Еда и напитки',
        key: 'count_food_drink',
      },
      {
        title: 'Услуги для населения',
        key: 'count_services_for_people',
      },
      {
        title: 'Розничная торговля',
        key: 'count_retail',
      },
      {
        title: 'Промышленность, строительство и B2B',
        key: 'count_industry',
      },
      {
        title: 'Финансы, право и страхование',
        key: 'count_finance',
      },
      {
        title: 'Образование (коммерческое)',
        key: 'count_education',
      },
      {
        title: 'Авто и транспорт',
        key: 'count_auto',
      },
    ],
  },
  {
    title: 'Разнообразие бизнеса',
    key: 'hhi',
  },
];

function HeatmapSelector() {
  const showHeatmap = useUnit($showHeatmap);
  const hexProperty = useUnit($hexProperty);
  const changeHexProperty = useUnit(changeHexPropertyEv);

  const onCheck = (checked, e) => {
    changeHexProperty(e.node.key);
  };

  return (
    <div
      className={[
        style.heatmap,
        showHeatmap ? style.show : style.hide,
        'glass',
      ].join(' ')}
    >
      <div className={style.heatmap_title}>Тепловая карта</div>
      <Tree
        checkedKeys={[hexProperty]}
        treeData={treeData}
        switcherIcon={<DownOutlined />}
        checkable
        multiple={false}
        selectable={false}
        onCheck={onCheck}
      />
    </div>
  );
}

export default HeatmapSelector;
